import styled from 'styled-components';
import Theme from '../../styles/models/theme';
import Icon from '../../components/atoms/Icon';

export const Container = styled.div<{theme: Theme}>`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div<{theme: Theme}>`
  display: flex;
  width: 100%;
  padding: 15px;
  flex-direction: column;
  background-color: ${({theme}) => theme.containerBackground};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const IconButton = styled(Icon)`
  margin-left: 8px;
  &:active {
    opacity: 0.8;
  }
`;

export const Title = styled.h1<{theme: Theme}>`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: ${({theme}) => theme.background};
`;
